export default "__VITE_ASSET__CsG3YplC__"